var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeBox"},[_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.formatDate))]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.day))]),_c('span',[_vm._v(_vm._s(_vm.formatTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }